<script setup>
import { computed, toRef, watch } from 'vue';
import ScheduledWorkflowTimelineCard from './ScheduledWorkflowTimelineCard.vue';
import { useScheduledWorkflowTimeline } from 'custom/composables/useScheduledWorkflowTimeline';

const props = defineProps({
  conversationId: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['updated']);
const { enabled, workflows } = useScheduledWorkflowTimeline(
  toRef(props, 'conversationId')
);
const workflowSignature = computed(() =>
  workflows.value
    .map(workflow => `${workflow.id}:${workflow.updated_at}`)
    .join('|')
);

watch(workflowSignature, () => emit('updated'), { flush: 'post' });
</script>

<template>
  <ScheduledWorkflowTimelineCard
    v-for="workflow in enabled ? workflows : []"
    :key="workflow.id"
    :workflow="workflow"
  />
</template>
